@if (isLoggedIn) {
  <div class="email__template">
    <div class="email__template--body no-data">
      <p>
        You are already logged in.
        Please <span class="logout" (click)="logout();">logout</span> to perform this action.
      </p>
    </div>
  </div>
}

@if (!isLoggedIn) {
  <div class="main-container">
    @if (validRegToken) {
      <div class="update_email_container">
        <div class="login-header"></div>
        <div  class="login-form flex-col" >
          <br>
            <h3 class="title">Update Email</h3>
            <br>
              @if (!isCurrentEmailVerified) {
                <form name="currentEmailForm"  [formGroup]="currentEmailForm"  (ngSubmit)="validateCurrentEmail(currentEmailForm.value)">
                  <p class="message">Please enter your current email to proceed</p>
                  <div class="input-container">
                    <label for="email"> Current {{'email' | translate}}</label>
                    <input class="form-field" type="text" id="email" name="email" formControlName="email" placeholder="{{'enter_email' | translate}}" required >
                  </div>
                  @if (email.invalid && (email.dirty || email.touched)) {
                    <div class="control-error-container error-msgs">
                      Enter valid email
                    </div>
                  }
                  <br>
                    <div class="input-container">
                      <label for="email"> New {{'email' | translate}}</label>
                      <input class="form-field" type="text" id="newEmail" name="newEmail" [disabled]="true" [value]="newEmail" required >
                    </div>
                    <br>
                      <div class="button-container">
                        <button class="submit-btn" [ngClass]="{'submit-btn-disabled': !currentEmalFormValid()}"  type="submit">Next</button>
                      </div>
                    </form>
                  }
                  @if (isCurrentEmailVerified) {
                    <form name="updateEmailForm"  [formGroup]="updateEmailForm"  (ngSubmit)="onSubmitUpdateEmail(updateEmailForm.value)">
                      <p class="message">Please set the new password for your account to proceed</p>
                      <div class="input-container">
                        <label for="password">{{'new_password' | translate}}</label>
                        <input class="form-field" type="password" id="password" name="pass" formControlName="password" required>
                      </div>
                      <div class="password_suggestion_div"> <span> Suggestion: </span> <span> {{passwordSuggestValue}} </span>
                      <span class="" (click)="copyPasswordToClipboard()"> <i class="fa fa-clipboard" aria-hidden="true" [title]="'copy'"></i> </span>
                      <span class="refresh_icon" (click)="generateRandomPassword()"><i class="fa fa-refresh" [title]="'refresh'"></i></span>
                    </div>
                    @if (password.invalid || (password.dirty || password.touched)) {
                      <div class="control-error-container error-msgs">
                        @if (password.errors?.minlength && !isDiverseyAdmin) {
                          <div>{{'must_8_characters_message' | translate}}</div>
                        }
                        @if (password.errors?.minlength && isDiverseyAdmin) {
                          <div> Must be at least 15 characters </div>
                        }
                        @if (password.errors?.maxlength) {
                          <div>{{'pass_max_length' | translate}}</div>
                        }
                        @if (password.errors?.pattern) {
                          <div>{{'lower_upper_case' | translate}}</div>
                        }
                      </div>
                    }
                    <div class="input-container">
                      <label for="confirmPass">{{'repeat_password' | translate}}</label>
                      <input class="form-field" type="password" id="confirmPass" name="confirmPass" formControlName="confirmPassword" required>
                    </div>
                    @if (confirmPassword.invalid || (confirmPassword.dirty || confirmPassword.touched)) {
                      <div class="control-error-container error-msgs">
                        @if (confirmPassword.errors?.MatchPassword) {
                          <div>{{'match' | translate}}</div>
                        }
                        @if (confirmPassword.errors?.maxlength) {
                          <div>{{'pass_max_length' | translate}}</div>
                        }
                      </div>
                    }
                    <div class="button-container">
                      <button class="submit-btn" [ngClass]="{'submit-btn-disabled': !updateEmalFormValid()}"  type="submit">Submit</button>
                    </div>
                  </form>
                }
              </div>
            </div>
          }
          @if (validRegToken === false) {
            <app-invalid-email-token ></app-invalid-email-token>
          }
          @if (loader) {
            <div class="site-loader-wrapper grey-bg-loader">
              <div class="loader"></div>
            </div>
          }
        </div>
      }